import PaperTypeTooltip from './PaperTypeTooltip';

export default PaperTypeTooltip;
